<div>
    <mat-chip-listbox [selectable]="selectable" [multiple]="multiple">
        <div class="d-flex flex-row align-items-center psic-gap-3">
            @for (pill of pills; track pill) {
            <mat-chip-option
                #mc
                [value]="pill"
                [selected]="pill.data.items && (pill.data.selectedItems > 0 || pill.dateSelected > 0)"
                class="caption-bold"
                [selectable]="selectable"
                [matMenuTriggerFor]="afterMenu"
                [matMenuTriggerData]="pill"
                [ngClass]="{ 'selected-background': pill.data.selectedItems || pill.selectedItems > 0 }"
                (click)="pill.data.isOpened = true"
            >
                <div class="d-flex flex-row align-items-center psic-gap-1">
                    {{ pill.data.name }}
                    @if ( (pill.data.selectedItems > 0 || pill.dateSelected > 0) 
                            && pill.data?.name !== COMM_SENT 
                            && pill.data?.name !== GEN_RCVD_DATE 
                            && pill.data?.name !== DATE_FILTER ) {
                        <span class="flnumber">
                            <span class="nmb">{{ pill.data.selectedItems }}</span>
                        </span>
                    }
                    <mat-icon
                        [svgIcon]="pill.data.isOpened ? 'chevron-up' : 'chevron-down'"
                        class="mat-icon-24"
                        [class.white-icon]="pill.data.selectedItems > 0 || pill.dateSelected > 0"
                    ></mat-icon>
                    @if ( pill.data && pill.data.selectedItems > 0 
                            && (pill.data?.name == COMM_SENT || pill.data?.name == GEN_RCVD_DATE || pill.data?.name == DATE_FILTER) ) {
                        <p class="pill-subtext disclaimer">
                            @if (pill.data?.items[0]?.from) {
                                <span>From {{ pill.data?.items[0]?.from | date : 'MM/dd/yyyy' }}&nbsp;to&nbsp; </span>
                            } @if (pill.data?.items[0]?.to) {
                                <span>{{ pill.data?.items[0]?.to | date : 'MM/dd/yyyy' }}</span>
                            }
                        </p>
                    }
                </div>
            </mat-chip-option>
            <mat-menu
                class="mat-menu-panel myMenu"
                #afterMenu="matMenu"
                yPosition="below"
                (closed)="clickOut(pill.data)"
            >
                <ng-template matMenuContent let-data="data">
                    @if ( pill.data?.name !== COMM_SENT && pill.data?.name !== GEN_RCVD_DATE && pill.data?.name !==
                    DATE_FILTER ) {
                    <div>
                        <div class="row psic-mb-4">
                            <div [ngClass]="multiple && pill.data.name !== FILTER_BY_NAME ? 'col-4' : 'col-12'">
                                <h6>{{ data.name }}</h6>
                            </div>
                            <div
                                [hidden]="!multiple || pill.data.name === FILTER_BY_NAME"
                                class="col-8 d-flex d-inline-flex justify-content-end"
                            >
                                <span class="caption-bold">All {{ data.name }}</span> &nbsp;&nbsp;
                                <lib-input-checkbox
                                    class="input-checkbox"
                                    name="Products"
                                    [(ngModel)]="data.selectAll"
                                    (click)="$event.stopPropagation()"
                                    (change)="selectAllItems(data)"
                                ></lib-input-checkbox>
                            </div>
                        </div>
                        @if (pill.data.name !== FILTER_BY_NAME && data.items.length >= 5) {
                        <mat-form-field class="example-form-field psic-mb-2">
                            <input matInput type="text" (click)="$event.stopPropagation()" [(ngModel)]="searchInput" />
                            @if (searchInput) {
                            <button
                                mat-button
                                matSuffix
                                mat-icon-button
                                class="searchInput"
                                (click)="$event.stopPropagation(); searchInput = ''"
                            >
                                @if (searchInput) {
                                <mat-icon
                                    class="mat-icon-20 dg_mg-60-color"
                                    [svgIcon]="'close-circle-filled'"
                                ></mat-icon>
                                }
                            </button>
                            }
                        </mat-form-field>
                        }
                        <div class="option">
                            @if (data.items.length >= 5) { @for (f of data.items | searchFilter : searchInput; track f){
                            <div class="option-item">
                                <ng-template [ngTemplateOutlet]="filteredItems" [ngTemplateOutletContext]="{ item: f }">
                                </ng-template>
                            </div>
                            } } @if (data.items.length < 5) { @for (f of data.items; track f){
                            <div class="option-item">
                                <ng-template [ngTemplateOutlet]="filteredItems" [ngTemplateOutletContext]="{ item: f }">
                                </ng-template>
                            </div>
                            } }
                        </div>
                        <ng-template #filteredItems let-f="item">
                            <div class="col-8 d-flex align-items-center psic-gap-2">
                                @if (data.name === 'Products') {
                                <img [src]="getProuductImg(f.key)" [alt]="f.image" style="width: 48px" />
                                }
                                <div class="option-item-text">
                                    <p class="caption-bold">{{ f.caption ? f.caption : f.key }}</p>
                                    <p [hidden]="!showSubtext" class="caption">{{ f.doc_count }} record(s)</p>
                                </div>
                            </div>
                            <div class="col-4" class="input-checkbox-content">
                                <lib-input-checkbox
                                    class="input-checkbox"
                                    [name]="data.name"
                                    [(ngModel)]="f.selected"
                                    (click)="$event.stopPropagation()"
                                    (change)="checkCount(data)"
                                >
                                </lib-input-checkbox>
                            </div>
                        </ng-template>
                        <div class="col-12" class="footerpart">
                            <lib-button
                                class="psic-mr-7"
                                [disabled]="false"
                                [buttonType]="'borderless'"
                                [buttonSize]="'medium'"
                                [buttonText]="'Cancel'"
                                (callback)="cancelCurrentFilter(data)"
                            ></lib-button>
                            <lib-button
                                (callback)="applyFilter(data)"
                                [disabled]="data.selectedItems == 0"
                                [buttonSize]="'medium'"
                                [buttonText]="'Apply Filter'"
                            ></lib-button>
                        </div>
                    </div>
                    } @if (pill.data.name === GEN_RCVD_DATE) {
                    <div tabIndex="1">
                        <div class="row">
                            <div [ngClass]="'col-12'">
                                <h6>{{ data.name }}</h6>
                            </div>
                        </div>
                        <div
                            (click)="$event.stopPropagation()"
                            [ngClass]="pill.data.name === GEN_RCVD_DATE ? 'calendar-div' : ''"
                        >
                            <lib-custom-range-calendar
                                [(ngModel)]="sentRangeValue"
                                (ngModelChange)="checkDate(data, $event)"
                            ></lib-custom-range-calendar>
                        </div>
                        <div class="col-12" class="footerpart">
                            <lib-button
                                class="psic-mr-7"
                                [disabled]="false"
                                [buttonType]="'borderless'"
                                [buttonSize]="'medium'"
                                [buttonText]="'Cancel'"
                                (callback)="cancelDateFilter(data)"
                            ></lib-button>
                            <lib-button
                                (callback)="applyFilter(data)"
                                [disabled]="false"
                                [buttonSize]="'medium'"
                                [buttonText]="'Apply Filter'"
                            ></lib-button>
                        </div>
                    </div>
                    } @if (pill.data.name === COMM_SENT) {
                    <div tabIndex="2">
                        <div class="row">
                            <div [ngClass]="'col-12'">
                                <h6>{{ data.name }}</h6>
                            </div>
                        </div>
                        <div
                            (click)="$event.stopPropagation()"
                            [ngClass]="pill.data.name === COMM_SENT ? 'calendar-div' : ''"
                        >
                            <lib-custom-range-calendar
                                [(ngModel)]="rcvdRangeValue"
                                (ngModelChange)="checkDate(data, $event)"
                            ></lib-custom-range-calendar>
                        </div>
                        <div class="col-12" class="footerpart">
                            <lib-button
                                class="psic-mr-7"
                                [disabled]="false"
                                [buttonType]="'borderless'"
                                [buttonSize]="'medium'"
                                [buttonText]="'Cancel'"
                                (callback)="cancelDateFilter(data)"
                            ></lib-button>
                            <lib-button
                                (callback)="applyFilter(data)"
                                [disabled]="false"
                                [buttonSize]="'medium'"
                                [buttonText]="'Apply Filter'"
                            ></lib-button>
                        </div>
                    </div>
                    } @if (pill.data.name === DATE_FILTER) {
                    <div tabIndex="3">
                        <div class="row">
                            <div [ngClass]="'col-12'">
                                <h6>{{ data.name }}</h6>
                            </div>
                        </div>
                        <div
                            (click)="$event.stopPropagation()"
                            [ngClass]="pill.data.name === DATE_FILTER ? 'calendar-div' : ''"
                        >
                            <lib-custom-range-calendar
                                [(ngModel)]="rcvdRangeValue"
                                (ngModelChange)="checkDate(data, $event)"
                            ></lib-custom-range-calendar>
                        </div>
                        <div class="col-12" class="footerpart">
                            <lib-button
                                class="psic-mr-7"
                                [disabled]="false"
                                [buttonType]="'borderless'"
                                [buttonSize]="'medium'"
                                [buttonText]="'Cancel'"
                                (callback)="cancelDateFilter(data)"
                            ></lib-button>
                            <lib-button
                                (callback)="applyFilter(data)"
                                [disabled]="false"
                                [buttonSize]="'medium'"
                                [buttonText]="'Apply Filter'"
                            ></lib-button>
                        </div>
                    </div>
                    }
                </ng-template>
            </mat-menu>
            }
        </div>
    </mat-chip-listbox>
</div>
